<template>
  <div class="boxshadow">
    <div class="bgshadow"></div>
    <div class="pd">
      <Dialog>
        <p class="msg">{{msg}}</p>
        <div class="confirm" @click="$emit('cancle')">确定</div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Dialog from "./Dialog";
export default {
  props: {
    msg: {
      type: String,
      default: "成功"
    }
  },
  components: {
    Dialog
  }
};
</script>

<style scoped lang="scss">
.boxshadow {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  .bgshadow {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  .msg {
    font-size: 40px;
    text-align: center;
    line-height: 350px;
  }
  .confirm {
    width: 100%;
    height: 110px;
    background: #ffdf32;
    text-align: center;
    line-height: 110px;
    font-size: 32px;
    color: #000;
    border-radius: 8px;
  }
  .pd {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
